<template>
  <div class="head">
    <el-menu
      :default-active="$route.path"
      class="el-menu-demo"
      :router="true"
      mode="horizontal"
      background-color="#E8E8E8"
      text-color="#666666"
      active-text-color="#C70000"
      :collapse-transition="false"
      :unique-opened="true"
    >
      <img
        src="@/assets/images/logo.png"
        alt="优加盟"
        class="logoimg"
        @click="gohome()"
      />
      <template v-for="item in $router.options.routes">
        <template v-if="item.children && item.children.length > 3">
          <el-submenu :index="item.path" :key="item.id" v-if="!item.meta.hide">
            <template slot="title">品牌管理</template>
            <!-- {{$route.meta.name}} -->
            <el-menu-item
              v-for="(items, index) in item.children"
              :index="items.path"
              :key="index"
              v-if="!items.meta.hide"
              class="is-active"
            >{{ items.meta.title }}
            </el-menu-item
            >
            <el-menu-item
              :index="items.path"
              v-else-if="
                items.name === 'brandtweet' && $store.getters.getTypeid === 3
              "
            >{{ items.meta.title }}
            </el-menu-item
            >
            <!-- <el-menu-item :index="items.path" v-else >{{items.meta.title}}</el-menu-item> -->
          </el-submenu>
        </template>
        <template v-else-if="item.children && item.children.length === 1">
          <el-menu-item
            v-for="(items, index) in item.children"
            :index="items.path"
            :key="items.path"
            v-if="!items.meta.hide"
          >
            <span
              slot="title"
              :class="[item.name === 'homepage' ? 'zhuye' : '']"
            >{{ items.meta.title }}</span
            >
          </el-menu-item>
        </template>
        <template v-else-if="item.children && item.children.length === 3">
          <el-menu-item
            v-for="(items, index) in item.children"
            :index="items.path"
            :key="items.path"
            v-if="!items.meta.hide"
          >
            <span
              slot="title"
              :class="[item.name === 'homepage' ? 'zhuye' : '']"
            >{{ items.meta.title }}</span
            >
          </el-menu-item>
        </template>
      </template>
    </el-menu>
    <ul class="el-menu-demo2">
      <li @click="open" class="eldemo2li">
        <i class="el-icon-switch-button"></i>
        <span>安全退出</span>
      </li>
      <li class="eldemo2li">
        <i class="el-icon-user"></i>
        <span>{{ mobile }}</span>
      </li>
      <li class="kefubox eldemo2li">
        <i class="el-icon-chat-dot-round"></i>
        <span>联系我们</span>
        <div class="erweimabox">
          <img src="https://img.yojiameng.com/yo/img/w_kefu.png" alt="优加盟"/>
          <p>扫码加客服微信</p>
          <span style="margin-top: 10px;" v-if="qrcodeurl">
            <img :src="qrcodeurl" alt="优加盟"/>
            <p>扫码公众号接收线索提醒</p>
          </span>
        </div>
      </li>
      <li @click="drawer = true" class="eldemo2li">
        <i class="el-icon-bell"></i>
        <span>
          消息
          <b>({{ $store.getters.getMsgtotalcount }})</b>
        </span>
      </li>

      <el-drawer :visible.sync="drawer" class="eldrawer">
        <div class="btnbox">
          <button @click="change(0)" :class="{ active: number === 0 }">
            全部
          </button>
          <button @click="change(1)" :class="{ active1: number === 1 }">
            未读
          </button>
        </div>
        <!-- <div v-if="listinfo.length > 0"> -->
        <div v-if="number === 0" class="allmsgbox">
          <div v-if="listinfo.length > 0">
            <h6>全部消息（{{ $store.getters.getMsgtotalcount }}）</h6>
            <el-timeline>
              <el-timeline-item
                v-for="(activity, index) in listinfo"
                :key="index"
                :timestamp="activity.addtime"
                placement="top"
              >
                <div class="allmsg_title">
                  <h5 :class="{ active2: activity.status === 2 }">
                    {{ activity.title }}
                    <i class="el-icon-delete" @click="del(activity.id)"></i>
                  </h5>
                </div>

                <p class="allmsgcontent" v-if="index == kindex">
                  {{ activity.content }}
                </p>
                <button
                  class="zhankai"
                  @click="zhankai(index, activity.id, activity.status)"
                  v-else
                >
                  展开查看
                </button>
                <button
                  class="zhankai"
                  @click="guanbi(index, activity.id)"
                  v-if="index == kindex"
                >
                  关闭
                </button>
              </el-timeline-item>
            </el-timeline>
            <el-pagination
              @current-change="handleCurrentChange"
              layout="prev, pager, next"
              :page-size="pageSize"
              :current-page="page"
              :total="totalcount"
            ></el-pagination>
          </div>
          <div v-else class="kongmsg">
            <h6>全部消息（{{ $store.getters.getMsgtotalcount }}）</h6>
            <img
              src="@/assets/images/kongzhuangt.svg"
              alt="优加盟"
              class="kongimg"
            />
            <p class="kongshuju">暂无消息</p>
          </div>
        </div>
        <div v-if="number === 1" class="allmsgbox">
          <div v-if="listinfo.length > 0">
            <h6>全部消息（{{ messageCount }}）</h6>
            <el-timeline>
              <el-timeline-item
                v-for="(activity, index) in listinfo"
                :key="index"
                :timestamp="activity.addtime"
                placement="top"
              >
                <div class="allmsg_title">
                  <h5 :class="{ active2: activity.status === 2 }">
                    {{ activity.title }}
                    <i class="el-icon-delete" @click="del(activity.id)"></i>
                  </h5>
                </div>

                <p class="allmsgcontent" v-if="index == kindex">
                  {{ activity.content }}
                </p>
                <button
                  class="zhankai"
                  @click="zhankai(index, activity.id, activity.status)"
                  v-else
                >
                  展开查看
                </button>
                <button
                  class="zhankai"
                  @click="guanbi(index, activity.id)"
                  v-if="index == kindex"
                >
                  关闭
                </button>
              </el-timeline-item>
            </el-timeline>
            <el-pagination
              @current-change="handleCurrentChange"
              layout="prev, pager, next"
              :page-size="pageSize"
              :current-page="page"
              :total="totalcount"
            ></el-pagination>
          </div>
          <div v-else class="kongmsg">
            <h6>全部消息（{{ totalcount }}）</h6>
            <img
              src="@/assets/images/kongzhuangt.svg"
              alt="优加盟"
              class="kongimg"
            />
            <p class="kongshuju">暂无消息</p>
          </div>
        </div>
      </el-drawer>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeIndex: "1",
      activeIndex2: "1",
      mobile: localStorage.getItem("mobile"),
      drawer: false,
      number: 0,
      kindex: -1,
      type: 1,
      listinfo: [],
      activeName: this.$router.path,
      totalcount: 0, //总数
      messageCount: null, //未阅读数量
      page: 1,
      pageSize: 5,
      currentPage: 1,
      qrcodeurl: ''
    };
  },
  methods: {
    handleCurrentChange(val) {
      this.page = val;
      this.getmessage();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getmessage();
    },
    gohome() {
      this.$router.push("/");
    },
    handleSelect(key, keyPath) {
      this.activeName = key;
    },
    change(zindex) {
      this.number = zindex; //重要处
      this.getmessage();
    },
    open() {
      this.$confirm("您将退出当前后台系统?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          // jimmy
          localStorage.clear();
          this.$router.push("/login");
        })
        .catch(() => {
        });
    },
    getmessage() {
      var token = localStorage.getItem("token");
      this.$axios
        .get("/user.php/v1/index/message/list", {
          params: {typeid: 0, page: this.page, status: this.number},
          headers: {
            token: token,
          },
        })
        .then((res) => {
          if (res.code === 200) {
            this.listinfo = res.data.listinfo;
            this.totalcount = res.data.totalcount;
            // console.log(this.totalcount)
            this.$store.dispatch("setMsgtotalcountAction", res.data.totalcount); //消息
            this.$store.dispatch("setTypeidAction", res.data.typeid); //账户类型
            this.messageCount = res.data.messageCount;
          } else {
            this.messageCount = res.data.messageCount;
            this.listinfo = 0;
            this.totalcount = 0;
          }
          this.getQrcodeurl(res.data.id)
        });
    },
    getQrcodeurl(id) {
      if (sessionStorage.getItem("qrcodeurl" + id)) {
        this.qrcodeurl = sessionStorage.getItem("qrcodeurl" + id)
      } else {
        this.$axios
          .get("/api.php/weixin/getQrcodeurl", {
            params: {id: id},
          })
          .then((res) => {
            if (res.code === 200) {
              this.qrcodeurl = res.data;
              sessionStorage.setItem("qrcodeurl" + id, res.data); //缓存token
            }
          });
      }
    },
    zhankai(index, id, status) {
      this.kindex = index;
      this.type = 2;
      var id = id;
      var token = localStorage.getItem("token");
      if (status == 1) {
        this.$axios
          .post(
            `/user.php/v1/index/message/save`,
            {status: 1, id: id},
            {
              headers: {
                token: token,
              },
            }
          )
          .then((res) => {
            if (res.code === 200) {
              this.getmessage();
            }
          });
      }
    },
    guanbi(index, id) {
      this.kindex = -1;
      this.type = 1;
      var id = id;
      var token = localStorage.getItem("token");
    },
    del(id) {
      var token = localStorage.getItem("token");
      var id = id;
      this.$axios
        .delete(`/user.php/v1/index/message/del?id=${id}`, {
          headers: {
            token: token,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.getmessage();
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            });
          }
        });
    },
  },
  mounted() {
    this.getmessage();
  }
};
</script>
<style lang="scss" scoped>
.head {
  height: 80px;
  background-color: #e8e8e8 !important;
  width: 100%;
}

/deep/ .el-menu-demo {
  height: 80px;
  float: left;
  width: 58%;
}

.el-menu--horizontal > .el-menu-item {
  .is-active {
    // border-left: 3px solid #c30d23;
    background-color: #f2f2f2;
    margin-top: 30px;
    color: #c30d23 !important;
  }
}

.el-menu--horizontal > .el-menu-item {
  height: 80px;
  line-height: 80px;
  padding: 0 13px;
  margin: 0px 2%;
}

/deep/ .el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 80px;
  line-height: 80px;
  padding: 0 15px;
  background-color: #e8e8e8 !important;
}

.el-submenu:hover {
  background-color: #e8e8e8 !important;
}

/deep/ .el-menu--horizontal > .el-submenu .el-submenu__title :hover {
  background-color: #f7f7f7 !important;
}

/deep/ .el-menu--horizontal > .el-submenu:focus,
.el-menu--horizontal > .el-submenu:hover {
  background-color: #e8e8e8 !important;
}

.el-menu-item:hover {
  background-color: #f7f7f7 !important;
}

.logoimg {
  width: 40px;
  height: 40px;
  float: left;
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 1.5%;
}

.el-menu-demo2 {
  width: 42%;
  height: 80px;
  float: right;
  background-color: #e8e8e8 !important;

  .eldemo2li {
    float: right;
    line-height: 80px;
    margin: 0px 3%;
    cursor: pointer;

    i {
      font-size: 24px;
      color: #666;
      line-height: 80px;
      float: left;
    }

    span {
      float: left;
      color: rgba(102, 102, 102, 1);
      font-size: 14px;
      margin-left: 6px;

      b {
        font-weight: normal;
        color: #c70000;
      }
    }
  }
}

.erweimabox {
  position: absolute;
  top: 65px;
  left: -55px;
  background-color: #fff;
  padding: 20px;
  text-align: center;
  z-index: 22;
  display: none;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);

  img {
    width: 160px;
    height: 160px;
    margin: auto;
    display: block;
  }

  p {
    margin-top: 10px;
    text-align: center;
    line-height: 21px;
    height: 21px;
    color: rgba(199, 0, 0, 1);
    font-size: 14px;
  }
}

.el-menu-demo2 li:hover {
  i {
    color: #c70000;
  }

  span {
    color: #c70000;
  }
}

.kefubox {
  position: relative;
}

.el-menu-demo2 .kefubox:hover {
  .erweimabox {
    display: block;
  }
}

/deep/ .el-drawer {
  width: 387px !important;
  overflow-y: scroll;
  overflow-x: hidden;
}

.eldrawer .el-drawer.ltr {
  width: 20% !important;
}

/deep/ .el-drawer__open .el-drawer.rtl {
  width: 20% !important;
}

/deep/ #el-drawer__title.el-drawer__header {
  margin-bottom: 10px !important;
  padding: 15px 20px 0 !important;
}

.btnbox {
  width: 53%;
  margin: auto;
  overflow: hidden;

  button {
    width: 50%;
    height: 34px;
    line-height: 34px;
    border-radius: 0px 5px 5px 0px;
    color: rgba(153, 153, 153, 1);
    font-size: 14px;
    background-color: #fff;
    text-align: center;
    border: 1px solid rgba(242, 242, 242, 1);
    float: left;
  }

  .active {
    background-color: rgba(199, 0, 0, 1);
    color: rgba(255, 255, 255, 1);
    font-size: 14px;
    text-align: center;
    border-radius: 5px 0px 0px 5px;
    border: 1px solid rgba(255, 255, 255, 0);
  }

  .active1 {
    background-color: rgba(199, 0, 0, 1);
    color: rgba(255, 255, 255, 1);
    font-size: 14px;
    text-align: center;
    // border-radius: 5px 0px 0px 5px;
    border: 1px solid rgba(255, 255, 255, 0);
  }
}

.allmsgbox {
  width: 100%;
  text-align: center;

  h6 {
    line-height: 21px;
    height: 21px;
    color: rgba(68, 68, 68, 1);
    font-size: 14px;
    text-align: center;
    margin-top: 30px;
    margin-bottom: 30px;
  }

  .allmsg_title {
    width: 100%;
    overflow: hidden;

    h5 {
      float: left;
      line-height: 24px;
      color: rgba(68, 68, 68, 1);
      font-size: 16px;

      i {
        // float: left;
        color: rgba(68, 68, 68, 1);
        font-size: 18px;
        margin-left: 12px;
        line-height: 24px;
        cursor: pointer;
      }
    }

    .active2 {
      color: #999999;
    }
  }

  .zhankai {
    width: 149px;
    height: 26px;
    line-height: 26px;
    border-radius: 3px;
    color: rgba(153, 153, 153, 1);
    font-size: 12px;
    text-align: center;
    background-color: #fff;
    border: 1px solid rgba(242, 242, 242, 1);
    margin-top: 10px;
    margin-bottom: 30px;
  }

  .allmsgcontent {
    text-align: left;
    line-height: 24px;
    color: rgba(102, 102, 102, 1);
    font-size: 14px;
    text-indent: 2em;
  }
}

.zhankai:hover {
  border: 1px solid #c70000;
  color: #c70000;
}

.el-icon-delete:hover {
  color: #666;
}

.allmsg_title:hover {
  h5 {
    color: #c70000;
  }

  .el-icon-delete {
    color: #666;
  }
}

/deep/ .el-timeline {
  width: 80% !important;
  margin: auto !important;
}

/deep/ .el-timeline-item__timestamp.is-top {
  text-align: left;
}

.el-pagination {
  // margin-top: 25px;
  text-align: center;
}

/deep/ .el-pager li.active {
  color: #c70000;
  //   cursor: default;
}

/deep/ .el-pagination .el-pager li:hover {
  color: #c70000;
}

/deep/ .el-pagination .el-pager li:not(.disabled):hover {
  color: #c70000;
}

.kongmsg {
  width: 100%;
  text-align: center;

  h6 {
    line-height: 21px;
    height: 21px;
    color: rgba(68, 68, 68, 1);
    font-size: 14px;
    text-align: center;
    margin-top: 30px;
    margin-bottom: 30px;
  }

  .kongimg {
    width: 243px;
    height: 181px;
  }

  .kongshuju {
    line-height: 21px;
    height: 21px;
    color: rgba(153, 153, 153, 1);
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/toubu.vue